import { DataGridPro } from '@mui/x-data-grid-pro';
import { sepPlansColumns } from './sepPlansColumns';
import { sepSpendGridStyle } from '../../shared/spendUtils';

export const SepPlansDatagrid = ({ rows }) => {
  const sortModel = [{ field: 'planStatus', sort: 'asc' }];

  return (
    <DataGridPro
      columns={sepPlansColumns}
      density="compact"
      rows={rows}
      autoHeight={true}
      getRowHeight={() => 'auto'}
      hideFooter={true}
      sx={(theme) => ({
        ...sepSpendGridStyle(theme),
        width: '100%',
        '& .MuiDataGrid-columnSeparator': {
          display: 'none'
        }
      })}
      initialState={{
        sorting: {
          sortModel: sortModel
        }
      }}
    />
  );
};
